import React, {useEffect} from 'react';
import withRouter from './common/withRouter';

//redux
import {useSelector} from "react-redux";

const NonAuthLayout = ({children, ...rest}) => {
    let show = rest.router.location.pathname !== "/eligibility-assessment"
    return (
        <div style={{marginLeft: 20, marginRight: 20}}>
            {children}
            {show &&
                <footer style={{marginTop: 10}}>
                    <p>Telehealth for Problems with Opioid Use - An NIH-funded study</p>
                    <p>Rebekah Heckmann, MD, PI, </p>
                    <p>Nasim Sabounchi, PhD, PI, </p>
                    <p>Yale School of Medicine, WCG IRB Protocol #2026191</p>
                    <p><a href={"https://www.oudtelehealth.com/"} target="_blank">https://www.oudtelehealth.com/</a></p>
                </footer>
            }
        </div>
    );
};

export default withRouter(NonAuthLayout);
